"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TranslationProvider = void 0;
const databases_templates_1 = require("databases.templates");
const pseudo_localization_1 = require("pseudo-localization");
const locales_1 = require("./locales");
const message_compiler_1 = require("./message_compiler");
const message_parser_1 = require("./message_parser");
class TranslationProvider {
    constructor(storage) {
        this.stringsDatabase = storage.getDatabase(databases_templates_1.STRINGS_COLLECTION_NAME);
    }
    /*
      Given an array of string ids, replace the default version with the provided locale version
    */
    getStringIds(ids, localeVersion) {
        let stringIds = ids;
        if (localeVersion && localeVersion !== 1) {
            stringIds = stringIds.map((id) => id.replace('~1_0', `~${localeVersion}_0`));
        }
        return stringIds;
    }
    getString(stringId, locale, translations) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!translations) {
                // eslint-disable-next-line no-param-reassign
                translations = yield this.stringsDatabase.getEntry(stringId).get();
            }
            if (translations === undefined) {
                throw new Error(`Translations not found for string ${stringId}.`);
            }
            let translation;
            if ((0, locales_1.isPseudoLocale)(locale)) {
                // Return english string for pseudolocales. Pseudolocalization should be done after parsing to avoid messing up
                // placeholders.
                translation = translations[locales_1.Locale.en_US];
            }
            else {
                translation = translations[locale];
            }
            if (translation === undefined) {
                throw new Error(`Translation missing in ${locale} for string ${stringId}.`);
            }
            return translation;
        });
    }
    /**
     * Returns the string with the given ID translated to the given locale as a function that takes in a params object and
     * resolves any placeholders in the string.
     */
    getStringAsFunction(stringId, locale, translations, localeVersion) {
        return __awaiter(this, void 0, void 0, function* () {
            const [id] = this.getStringIds([stringId], localeVersion);
            const message = yield this.getString(id, locale, translations);
            try {
                const parsedMessage = (0, message_parser_1.parseMessage)(message);
                const pseudolocalizedMessage = pseudolocalizeMessage(parsedMessage, locale);
                return eval((0, message_compiler_1.compileMessage)(pseudolocalizedMessage));
            }
            catch (error) {
                console.error(`Failed to parse/compile string as function. id: ${stringId}, locale: ${locale}, message: ${message}\n${error}`);
                throw error;
            }
        });
    }
    /**
     * Returns the string with the given ID translated to the given locale as a string of JS code that evals to a function
     * that takes in a params object and resolves any placeholders in the string.
     */
    getStringAsCode(stringId, locale, translations, localeVersion) {
        return __awaiter(this, void 0, void 0, function* () {
            const [id] = this.getStringIds([stringId], localeVersion);
            const message = yield this.getString(id, locale, translations);
            try {
                const parsedMessage = (0, message_parser_1.parseMessage)(message);
                const pseudolocalizedMessage = pseudolocalizeMessage(parsedMessage, locale);
                return (0, message_compiler_1.compileMessage)(pseudolocalizedMessage);
            }
            catch (error) {
                console.error(`Failed to parse/compile string as code. id: ${stringId}, locale: ${locale}, message: ${message}\n${error}`);
                throw error;
            }
        });
    }
    /**
     *
     * @param ids array of string IDs
     * @returns a hashmap of string ID and associated translations
     */
    loadStringsByIds(ids, version) {
        return __awaiter(this, void 0, void 0, function* () {
            let stringIds = ids;
            if (!stringIds.length) {
                return;
            }
            stringIds = this.getStringIds(stringIds, version);
            return this.stringsDatabase.getDataEntriesByIds(stringIds);
        });
    }
}
exports.TranslationProvider = TranslationProvider;
function pseudolocalizeMessage(message, locale) {
    if ((0, locales_1.isPseudoLocale)(locale)) {
        if (typeof message === 'string') {
            return pseudolocalizeString(message, locale);
        }
        return message.map((node) => {
            if (typeof node === 'string') {
                return pseudolocalizeString(node, locale);
            }
            // Html tags and regular param placeholders have nothing to pseudolocalize.
            return node;
        });
    }
    // Don't pseudolocalize real locales.
    return message;
}
function pseudolocalizeString(string, locale) {
    return (0, pseudo_localization_1.localize)(string, { strategy: locale.toString() === locales_1.PseudoLocale.ar_XB ? 'bidi' : 'accented' });
}
//# sourceMappingURL=translation_provider.js.map